import { registerSW } from 'virtual:pwa-register';
import { createWarehouseUpdates } from './controller';
import { warehouseUpdateOverview } from '../navigation';
import { warehouseWrites } from './activity';
export const warehouseUpdatesSupported = import.meta.env.PROD && 'serviceWorker' in navigator;
let applyUpdate: (() => Promise<void>) | null = null;
let registration: ServiceWorkerRegistration | undefined; let started = false; let checkedAt = 0;
let registering: Promise<void> | null = null;
export const warehouseUpdates = createWarehouseUpdates({
  canReload: () => warehouseUpdateOverview(window.location.pathname) && document.visibilityState === 'visible' && warehouseWrites.snapshot() === 0,
  reload: () => window.location.reload(),
  apply: async () => { if (!applyUpdate) throw new Error('Update registration unavailable'); await applyUpdate(); },
  check: async () => { if (!registration) await registerWorker(); else await registration.update(); checkedAt = Date.now(); },
}, navigator.onLine);
function registerWorker() {
  if (!warehouseUpdatesSupported) return Promise.reject(new Error('App updates are unavailable in this browser'));
  if (registering) return registering;
  registering = new Promise<void>((resolve, reject) => {
    applyUpdate = registerSW({
      immediate: true,
      onNeedRefresh: warehouseUpdates.waiting,
      onNeedReload: warehouseUpdates.activated,
      onRegisteredSW: (_url, value) => { registration = value; checkedAt = Date.now(); if (value) resolve(); else reject(new Error('Registration unavailable')); },
      onRegisterError: reject,
    });
  });
  const pending = registering;
  void pending.then(() => { registering = null; }, () => { registering = null; });
  return pending;
}
export function startWarehouseUpdates() {
  if (started || !warehouseUpdatesSupported) return; started = true;
  let previous = navigator.serviceWorker.controller;
  // Another tab can activate the worker. It must never reload this tab's form.
  navigator.serviceWorker.addEventListener('controllerchange', () => { if (previous) warehouseUpdates.activated(); previous = navigator.serviceWorker.controller; });
  const check = () => { if (document.visibilityState === 'visible' && navigator.onLine && Date.now() - checkedAt > 5 * 60 * 1000) { checkedAt = Date.now(); void warehouseUpdates.check(); } };
  window.addEventListener('online', () => { warehouseUpdates.network(true); check(); });
  window.addEventListener('offline', () => warehouseUpdates.network(false));
  document.addEventListener('visibilitychange', check); window.addEventListener('focus', check);
  setInterval(check, 5 * 60 * 1000);
  void registerWorker().catch(warehouseUpdates.issue);
}
